import { useCallback, useEffect, useState } from "react";
import { OVERTIME_ICONS } from "../../../../assets/icons/overtime";
import OverTimeCard from "../../anality/OverTimeCard";

const OverTimeCardsSection = ({ quantities, totalProjects = 0 }) => {
    const updateCards = useCallback(() => {
        return Object.entries(quantities).reduce((prev, [_, value]) => {
            const percentage = parseFloat(((100 * value?.times) / totalProjects).toFixed(2));

            if (!prev) return [value.title, percentage];
            if (prev[1] < percentage) return [value.title, percentage];

            return prev;
        }, null);
    }, [quantities, totalProjects]);

    const [mostImportantProblem, setMostImportantProblem] = useState(updateCards);

    useEffect(() => {
        const card = updateCards();
        setMostImportantProblem(card);
    }, [updateCards]);

    const {
        negotiation = { times: 0 },
        quality = { times: 0 },
        technical_difficulty = { times: 0 },
        technical_knowledge = { times: 0 },
        management_monitoring = { times: 0 },
        missing_documentation = { times: 0 },
        quotation = { times: 0 },
        pause = { times: 0 },
        provider = { times: 0 },
    } = quantities;
    return (
        <div className="flex flex-wrap gap-5 justify-center md:w-[600px] md:m-auto">
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={negotiation.times}
                section={negotiation?.title}
                title={"Negociación"}
                img={OVERTIME_ICONS.money_symbol}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={quality.times}
                section={quality?.title}
                title={"Calidad"}
                img={OVERTIME_ICONS.quality}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={technical_difficulty?.times || 0}
                section={technical_difficulty?.title}
                title={"Dificultad técnica"}
                img={OVERTIME_ICONS.hard_work}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={technical_knowledge?.times || 0}
                section={technical_knowledge?.title}
                title={"Conocimiento técnico"}
                img={OVERTIME_ICONS.technical}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={management_monitoring?.times || 0}
                section={management_monitoring?.title}
                title={"Seguimiento gestión"}
                img={OVERTIME_ICONS.calendar}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={missing_documentation?.times || 0}
                section={missing_documentation?.title}
                title={"Falta de documentación"}
                img={OVERTIME_ICONS.documentation}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={quotation.times}
                section={quotation?.title}
                title={"Cotización"}
                img={OVERTIME_ICONS.money_symbol}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={pause.times}
                section={pause?.title}
                title={"Pausa"}
                img={OVERTIME_ICONS.pause}
            />
            <OverTimeCard
                mostImportantProblem={mostImportantProblem}
                totalProjects={totalProjects}
                time={provider.times}
                section={provider?.title}
                title={"Proveedor"}
                img={OVERTIME_ICONS.provider}
            />
        </div>
    );
};

export default OverTimeCardsSection;
